import { visibilityUiActions } from 'affiny-core/modules/visibilityUi/actions';
import useQuery from 'affiny-desktop/src/hooks/query';
import { Box } from 'affiny-ui/src';
import { AnimatePresence, motion } from 'framer-motion';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import CompatibilityReportLayer from '../compatibility-report/CompatibilityReportLayer';
import { PersonalityReportLayer } from '../personality-report/PersonalityReportLayer';
import { LayerHeader } from './LayerHeader';

const DURATION_ANIMATION = 0.7;

export const Layer = () => {
  const dispatch = useDispatch();
  const [showLayer, setShowLayer] = useState(false);
  const [showPersonalityReport, setShowPersonalityReport] = useState(false);
  const [showCompatibilityReport, setShowCompatibilityReport] = useState(false);
  const query = useQuery();
  const history = useHistory();

  const handleClose = useCallback(async () => {
    dispatch(visibilityUiActions.showMainLayout());
    setShowPersonalityReport(false);
    setShowLayer(false);
    setShowCompatibilityReport(false);
    document.body.style.overflowY = 'auto';
    history.replace({ search: '' });
  }, [history, dispatch]);

  const onQueryChange = useCallback(
    (query: URLSearchParams) => {
      switch (query.get('target')) {
        case 'personality-report':
          setShowLayer(true);
          setShowPersonalityReport(true);
          dispatch(visibilityUiActions.hideMainLayout());
          break;
        case 'compatibility-report':
          setShowLayer(true);
          setShowCompatibilityReport(true);
          dispatch(visibilityUiActions.hideMainLayout());
          break;
      }
    },
    [setShowLayer, dispatch]
  );

  history.listen(location => {
    onQueryChange(new URLSearchParams(location.search));
  });

  useEffect(() => {
    onQueryChange(query);
  }, [query, onQueryChange]);

  if (!showLayer) {
    return null;
  }

  return (
    <AnimatePresence initial={showPersonalityReport}>
      <TranslationProvider
        initial={{
          y: window.innerHeight,
          opacity: 0,
        }}
        animate={{
          transition: { duration: DURATION_ANIMATION },
          y: 0,
          opacity: 1,
        }}
        exit={{
          transition: { duration: DURATION_ANIMATION },
          y: window.innerHeight,
          opacity: 0,
        }}
      >
        <LayerHeader onClose={handleClose} />
        <Box
          maxWidth={[720, 960, 1280]}
          boxSizing="content-box"
          width="100%"
          minHeight="100vh"
          alignItems="center"
          justifyContent="center"
          flexDirection="column"
          zIndex={102}
          backgroundColor="light"
          paddingX={0}
          mx="auto"
        >
          {showPersonalityReport && <PersonalityReportLayer />}
          {showCompatibilityReport && <CompatibilityReportLayer />}
        </Box>
      </TranslationProvider>
    </AnimatePresence>
  );
};

const TranslationProvider = styled(motion.div)`
  display: flex;
  top: 0;
  flex-direction: column;
  justify-content: center;
  flex-grow: 1;
  flex-shrink: 0;
  height: 100%;
  width: 100%;
`;
